module.exports = __webpack_public_path__ + "img/linenotify_logo.a7eedb54.png";